export const getApiBaseUrl = () => {
    return 'http://127.0.0.1:8000/api';
};

export const getStorageUrl = (path: string): string => {
    const BASE_URL = 'http://127.0.0.1:8000/storage/';
    return `${BASE_URL}${path}`;
};
